import clsx from 'clsx';

export const SvgPlay = ({ className, handleClick }) => (
  <button
    className={clsx('group absolute cursor-pointer', className)}
    onClick={handleClick}
  >
    <svg
      enableBackground="new 0 0 40 40"
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>play video button</title>
      <path
        id="play-button-path"
        className="fill-parlor-green-80 group-hover:fill-parlor-green transition duration-500 ease-in-out"
        d="m20 0c11 0 20 9 20 20 0 11-9 20-20 20-11 0-20-9-20-20 0-11 9-20 20-20z"
      ></path>
      <path
        d="m14 25.3v-10.6c0-.9 0-1.3.2-1.6.2-.2.4-.4.7-.4s.7.2 1.5.6l10 5.3c.9.5 1.3.7 1.4 1s.1.6 0 .8c-.1.3-.6.5-1.4 1l-10 5.3c-.8.4-1.2.6-1.5.6s-.5-.2-.7-.4-.2-.7-.2-1.6z"
        fill="#fff"
      ></path>
    </svg>
  </button>
);
